import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"

import SbImageService from "../../helpers/SbImageService"
import linkHandler from "../../helpers/storyblokLinkHandler"
import MetaIcons from "../meta-icons"

function getMetaTags(md, path) {
  const metaData = [
    {
      name: "description",
      content: md.meta_description,
    },
    {
      property: "og:url",
      content: process.env.GATSBY_HOST + path,
    },
    {
      property: "og:title",
      content: md.meta_title,
    },
    {
      property: "og:description",
      content: md.meta_description,
    },
    {
      name: "twitter:description",
      property: "twitter:description",
      content: md.meta_description,
    },
  ]

  if (md.twitter_image) {
    metaData.push({
      name: "twitter:image",
      property: "twitter:image",
      content: `https:${SbImageService(md.twitter_image)}`,
    })
  }
  if (md.og_image) {
    metaData.push({
      property: "og:image",
      content: `https:${SbImageService(md.og_image)}`,
    })
  }
  if (md.og_video && md.og_video.id) {
    metaData.push({
      name: "og:video",
      content: linkHandler(md.og_video),
    })
  }
  if (md.no_index) {
    metaData.push({
      name: "robots",
      content: "noindex, nofollow",
    })
  }

  return metaData
}

function getLinkTags(md) {
  const headerLink = []

  if (md.canonical_link && md.canonical_link.id !== "") {
    headerLink.push({
      rel: "canonical",
      href: linkHandler(md.canonical_link),
    })
  }

  return headerLink
}

const MetaData = ({ meta_data, path }) => (
  <>
    {Array.isArray(meta_data.meta_icons) && meta_data.meta_icons.length ? (
      <MetaIcons
        favicon={meta_data.meta_icons[0].favicon}
        appleTouchIcon192={meta_data.meta_icons[0].apple_touch_icon_192}
        appleTouchIcon512={meta_data.meta_icons[0].apple_touch_icon_512}
      />
    ) : (
      <Helmet
        link={[
          {
            rel: "icon",
            type: "image/png",
            href: "/favicons/hult-48x48.png",
          },
          {
            rel: "apple-touch-icon",
            sizes: "192x192",
            href: "/favicons/apple-touch-icons/hult/hult-192x192.png",
          },
          {
            rel: "apple-touch-icon",
            sizes: "512x512",
            href: "/favicons/apple-touch-icons/hult/hult-512x512.png",
          },
        ]}
      />
    )}
    <Helmet
      title={meta_data.meta_title}
      meta={getMetaTags(meta_data, path)}
      link={getLinkTags(meta_data, path)}
    />
  </>
)

MetaData.propTypes = {
  meta_data: PropTypes.shape({
    meta_title: PropTypes.string,
    meta_description: PropTypes.string,
    twitter_image: PropTypes.string,
    og_image: PropTypes.string,
    og_video: PropTypes.shape({
      linktype: PropTypes.string,
      cached_url: PropTypes.string,
      url: PropTypes.string,
    }),
    canonical_link: PropTypes.shape({
      linktype: PropTypes.string,
      cached_url: PropTypes.string,
      url: PropTypes.string,
    }),
    no_index: PropTypes.bool,
  }).isRequired,
  path: PropTypes.string.isRequired,
}

export default MetaData
